import {
  faDownload,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { Card, CardBody, CardHeader } from 'reactstrap'
import {
  deleteApplication,
  setAreYouSureModalData,
  setJobDetailRoute,
  updateJobApplication,
} from 'store/Recruitment/actions'
import { JOB_DETAIL_APPLICATIONS } from 'store/Recruitment/reducer'
import AxiosInstance, { clientBaseUrl } from 'utils/AxiosInstance'
import defaultAvatar from '../../../../../assets/img/brand/img_avatar.png'
import AddToJobOnboard from './AddToJobOnboard'
import CreateInterviewModal from './CreateInterviewModal'
import { setAllJobApplicationsAndJobs } from 'store/Recruitment/actions'
import { getTrackedApplication } from 'store/Recruitment/actions'
import { formatToAmPm } from 'utils/helpers'

function Details({ onDeleteFn, viewOnly = false }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const { jobApplication } = useSelector((store) => store.recruitment)

  const interviewDateStr = jobApplication?.interview_date
  const interviewTimeStr = jobApplication?.interview_start_time

  let isWithinWindow = false

  if (interviewDateStr && jobApplication?.with_ai === 1) {
    // For AI interviews, only check if dates match (allow access all day)
    const today = new Date()
    const interviewDate = new Date(interviewDateStr)

    // Compare only the date parts (ignore time)
    const todayDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    )
    const interviewDateOnly = new Date(
      interviewDate.getFullYear(),
      interviewDate.getMonth(),
      interviewDate.getDate()
    )

    isWithinWindow = todayDate.getTime() === interviewDateOnly.getTime()
  } else if (interviewDateStr && interviewTimeStr) {
    // For regular interviews, check the 15-minute time window
    const now = new Date()

    const [hours, minutes] = interviewTimeStr.split(':').map(Number)
    const interviewStart = new Date(interviewDateStr)
    interviewStart.setHours(hours, minutes, 0, 0)

    const interviewEnd = new Date(interviewStart)
    interviewEnd.setMinutes(interviewStart.getMinutes() + 15)

    isWithinWindow = now >= interviewStart && now <= interviewEnd
  }

  const [showModal, setShowModal] = useState(false)
  const [jobStages, setJobStages] = useState([])

  const [showCreateInterviewModal, setShowCreateInterviewModal] =
    useState(false)

  const [showOnboardingModal, setShowOnboardingModal] = useState(false)

  const interViewStage = jobStages?.find((el) => el?.interview_stage === 'true')

  const hiredStage = jobStages?.find((el) => el?.hired_stage === 'true')

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/job_stage`).then((data) =>
      setJobStages(
        data?.map((el) => {
          return {
            name: el?.value,
            id: el?.id,
            interview_stage: el?.interview_stage,
            hired_stage: el?.hired_stage,
          }
        })
      )
    )
  }, [])

  useEffect(() => {
    if (viewOnly) {
      dispatch(
        getTrackedApplication({
          tracking_id: location?.search?.split('=')?.at(1)?.split('&')?.at(0),
          email: location?.search?.split('=')?.at(2),
        })
      )
    }
  }, [viewOnly, dispatch, location?.search])

  return (
    <div
      className='d-flex align-items-start justify-content-between'
      style={{ gap: '2rem' }}
    >
      <div className='d-flex flex-column w-50'>
        <Card>
          <CardHeader className='title d-flex justify-content-between align-items-center'>
            Basic Details
            {!viewOnly && (
              <div className='d-flex align-items-center'>
                <button
                  className='btn btn-info py-1'
                  onClick={() => {
                    dispatch(
                      setAreYouSureModalData({
                        show: true,
                        customFn: () =>
                          dispatch(
                            updateJobApplication(jobApplication?.id, {
                              archived: jobApplication?.archived ? 0 : 1,
                            })
                          ),
                      })
                    )
                  }}
                >
                  {!jobApplication?.archived ? 'Archive' : 'UnArchive'}
                </button>
                {!jobApplication?.archived ? (
                  <button
                    className='btn btn-danger py-1 ml-2'
                    onClick={() => {
                      dispatch(
                        setAreYouSureModalData({
                          show: true,
                          customFn: () => {
                            dispatch(
                              deleteApplication(
                                jobApplication?.id,
                                jobApplication?.job_id
                              )
                            )
                            if (location?.pathname !== '/job-application') {
                              history.push(
                                `/job/details?job=${jobApplication?.job_id}`
                              )
                              dispatch(
                                setJobDetailRoute(JOB_DETAIL_APPLICATIONS)
                              )
                            } else {
                              dispatch(setAllJobApplicationsAndJobs())
                              history.push('/job-application')
                              onDeleteFn()
                            }
                          },
                        })
                      )
                    }}
                  >
                    Delete
                  </button>
                ) : null}
              </div>
            )}
          </CardHeader>
          <CardHeader className='d-flex align-items-center'>
            <img
              src={
                jobApplication?.profile
                  ? jobApplication?.profile
                  : defaultAvatar
              }
              alt='profileImage'
              className='rounded border-warning border border-4 object-fit-cover'
              style={{ width: '50px', height: '50px', objectFit: 'cover' }}
              role='button'
              onClick={() => window.open(jobApplication?.profile, '_blank')}
            />
            <div className='d-flex flex-column ml-3 font-weight-bold'>
              <span className='text-dark'>{jobApplication?.name}</span>
              <span className='text-dark'>{jobApplication?.email}</span>
            </div>
            {viewOnly && (
              <div className='d-flex align-items-center ml-auto ml-auto'>
                <h4 className='font-weigt-bold mt-1 mr-2'>Status:</h4>
                <button
                  className='btn btn-info py-1'
                  onClick={(e) => e.preventDefault()}
                  type='button'
                  tabIndex={-1}
                  style={{ pointerEvents: 'none' }}
                >
                  {jobStages?.find(
                    (stage) => stage?.id === jobApplication?.job_stage
                  )?.name ?? ''}
                </button>
              </div>
            )}
          </CardHeader>
          {!viewOnly && (
            <CardBody>
              {jobStages?.map((stage) => (
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    defaultChecked={false}
                    id={stage?.id}
                    type='radio'
                    name='job_stage'
                    checked={stage?.id === jobApplication?.job_stage}
                    onChange={() => {
                      if (interViewStage) {
                        if (stage?.id === interViewStage?.id) {
                          setShowCreateInterviewModal(true)
                          return
                        }
                      }

                      if (hiredStage) {
                        if (stage?.id === hiredStage?.id) {
                          setShowOnboardingModal(true)
                          return
                        }
                      }

                      if (
                        jobApplication?.job_stage === interViewStage?.id &&
                        stage?.id !== interViewStage?.id
                      ) {
                        dispatch(
                          setAreYouSureModalData({
                            show: true,
                            text: 'All scheduled interviews with this candidate will be removed!',
                            customFn: () =>
                              dispatch(
                                updateJobApplication(jobApplication?.id, {
                                  job_stage: stage?.id,
                                })
                              ),
                          })
                        )
                        return
                      }

                      if (
                        jobApplication?.job_stage === hiredStage?.id &&
                        stage?.id !== hiredStage?.id
                      ) {
                        dispatch(
                          setAreYouSureModalData({
                            show: true,
                            text: 'Candidate will be removed from job onboarding',
                            customFn: () =>
                              dispatch(
                                updateJobApplication(jobApplication?.id, {
                                  job_stage: stage?.id,
                                })
                              ),
                          })
                        )
                        return
                      }

                      dispatch(
                        updateJobApplication(jobApplication?.id, {
                          job_stage: stage?.id,
                        })
                      )
                    }}
                  />
                  <label className='custom-control-label' htmlFor={stage?.id}>
                    {stage?.name}
                  </label>
                </div>
              ))}
            </CardBody>
          )}
        </Card>
        {viewOnly && (
          <Card>
            <CardHeader className='title'>Additional Details</CardHeader>
            <CardBody className='d-flex flex-column' style={{ gap: '0.7rem' }}>
              <span className='font-weight-bold'>
                Interview date:{' '}
                <span className='font-weight-normal'>
                  {jobApplication?.interview_date
                    ? moment(jobApplication?.interview_date).format(
                        'DD-MM-YYYY'
                      )
                    : '-'}
                </span>
              </span>
              {!jobApplication?.with_ai ? (
                <span className='font-weight-bold'>
                  Interview time:{' '}
                  <span className='font-weight-normal'>
                    {jobApplication?.interview_start_time ? (
                      <>
                        {formatToAmPm(jobApplication?.interview_start_time)} -{' '}
                        {jobApplication?.interview_end_time
                          ? formatToAmPm(jobApplication?.interview_end_time)
                          : '?'}
                      </>
                    ) : (
                      '-'
                    )}
                  </span>
                </span>
              ) : null}

              {console.log(jobApplication, 'leart323')}

              <span className='font-weight-bold'>
                Meeting Info:{' '}
                <span className='font-weight-normal'>
                  {jobApplication?.meeting_info ?? '-'}
                </span>
              </span>
              {jobApplication?.with_ai ? (
                <div className='my-2'>
                  {!isWithinWindow && (
                    <p className='text-muted'>Interview not available yet.</p>
                  )}
                  <Link
                    to={`/job/ai-interview?application_id=${jobApplication?.id}&email=${jobApplication?.email}&interview_id=${jobApplication?.interview_id}`}
                    className='btn btn-info'
                    style={{ width: 'fit-content' }}
                    disabled={!isWithinWindow}
                  >
                    Take Interview
                  </Link>
                </div>
              ) : null}
            </CardBody>
          </Card>
        )}
      </div>
      <Card className='w-50'>
        <CardHeader className='title d-flex align-items-center justify-content-between'>
          Basic Information{' '}
          {jobApplication?.job_stage !== hiredStage?.id && !viewOnly && (
            <button
              className='btn btn-info py-1'
              onClick={() => setShowModal(true)}
            >
              + Add to Job OnBoard
            </button>
          )}
        </CardHeader>

        <CardBody>
          <BasicInfo label='Phone' value={jobApplication?.phone} />
          <BasicInfo
            label='DOB'
            value={
              jobApplication?.date_of_birth &&
              jobApplication?.date_of_birth !== '0000-00-00 00:00:00'
                ? moment(jobApplication?.date_of_birth).format('DD-MM-YYYY')
                : '-'
            }
          />
          <BasicInfo
            label='Gender'
            value={
              !jobApplication?.gender
                ? '-'
                : jobApplication?.gender === 'm'
                ? 'Male'
                : 'Female'
            }
          />
          <BasicInfo label='Country' value={jobApplication?.country} />
          <BasicInfo label='Applied For' value={jobApplication?.job_title} />
          <BasicInfo
            label='Applied at'
            value={moment(jobApplication?.created_at).format('DD-MM-YYYY')}
          />
          <BasicInfo
            label='CV / Resume'
            value={
              jobApplication?.resume ? (
                <div
                  className='d-flex align-items-center'
                  style={{ gap: '1rem' }}
                >
                  <FontAwesomeIcon
                    size='xl'
                    icon={faDownload}
                    title='Download'
                    role='button'
                    className='text-success'
                    onClick={() => {
                      const url = clientBaseUrl()
                      const resumeUrl = encodeURIComponent(
                        jobApplication?.resume
                      )
                      const proxyUrl = `${url}/recruitment/proxy-resume?url=${resumeUrl}`

                      const link = document.createElement('a')
                      link.href = proxyUrl
                      link.setAttribute('download', '')
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                    }}
                  />
                  <FontAwesomeIcon
                    size='xl'
                    icon={faMagnifyingGlass}
                    title='View'
                    role='button'
                    className='text-info'
                    onClick={() => {
                      window.open(jobApplication?.resume, '_blank')
                    }}
                  />
                </div>
              ) : (
                '-'
              )
            }
          />
          <BasicInfo
            label='Cover Letter'
            value={jobApplication?.cover_letter}
          />
        </CardBody>
      </Card>
      {showModal && (
        <AddToJobOnboard showModal={showModal} setShowModal={setShowModal} />
      )}
      {showCreateInterviewModal && (
        <CreateInterviewModal
          showModal={showCreateInterviewModal}
          setShowModal={setShowCreateInterviewModal}
        />
      )}
      {showOnboardingModal && (
        <AddToJobOnboard
          showModal={showOnboardingModal}
          setShowModal={setShowOnboardingModal}
        />
      )}
    </div>
  )
}

function BasicInfo({ label, value }) {
  return (
    <div className='row mb-2 py-2'>
      <div className='col-3 font-weight-bold'>{label}</div>
      <div className='col-9'>{value ?? '-'}</div>
    </div>
  )
}

export default Details
